import { useSyncExternalStore } from 'react';

const queries = {
  sm: '(max-width: 47.9375rem)', // 767px / 16
  md: '(min-width: 48rem) and (max-width: 63.9375rem)', // 768px / 16, 1023px / 16
  lg: '(min-width: 64rem) and (max-width: 79.9375rem)', // 1024px / 16, 1279px / 16
  xl: '(min-width: 80rem) and (max-width: 95.9375rem)', // 1280px / 16, 1535px / 16
  xxl: '(min-width: 96rem)', // 1536px / 16

  minMd: '(min-width: 48rem)', // ≥ 768px
  minLg: '(min-width: 64rem)', // ≥ 1024px
  minXl: '(min-width: 80rem)', // ≥ 1280px
  minXxl: '(min-width: 96rem)', // ≥ 1536px
} as const;

const subscribe = (callback: () => void, query: string): (() => void) => {
  const mediaQuery: MediaQueryList = window.matchMedia(query);
  mediaQuery.addEventListener('change', callback);
  return () => mediaQuery.removeEventListener('change', callback);
};

const getSnapshot = (query: string): boolean => {
  return window.matchMedia(query).matches;
};

const useBreakpoint = (query: string): boolean => {
  return useSyncExternalStore(
    (callback) => subscribe(callback, query),
    () => getSnapshot(query),
    () => false,
  );
};

export const useBreakpointSm = () => useBreakpoint(queries.sm);
export const useBreakpointMd = () => useBreakpoint(queries.md);
export const useBreakpointLg = () => useBreakpoint(queries.lg);
export const useBreakpointXl = () => useBreakpoint(queries.xl);
export const useBreakpointXxl = () => useBreakpoint(queries.xxl);

export const useBreakpointMinMd = () => useBreakpoint(queries.minMd);
export const useBreakpointMinLg = () => useBreakpoint(queries.minLg);
export const useBreakpointMinXl = () => useBreakpoint(queries.minXl);
export const useBreakpointMinXxl = () => useBreakpoint(queries.minXxl);

export function useBreakpointMap() {
  return {
    sm: useBreakpointSm(),
    md: useBreakpointMd(),
    lg: useBreakpointLg(),
    xl: useBreakpointXl(),
    xxl: useBreakpointXxl(),
    minMd: useBreakpointMinMd(),
    minLg: useBreakpointMinLg(),
    minXl: useBreakpointMinXl(),
    minXxl: useBreakpointMinXxl(),
  };
}

export default useBreakpoint;
